import styled from "styled-components"

import { NCaptionS, NFontWeight } from "@assets/styles/newTypographyStyles"

export const Description = styled(NCaptionS)`
  color: var(--gray4);
  font-weight: ${NFontWeight.medium};
  text-align: center;
`
